import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _dec3, _dec4, _class, _class2, _descriptor, _descriptor2, _descriptor3, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "90e0bI95vFOB7hKPZMEn3S+", "Loading", undefined);

import { _decorator, Component, ProgressBar, JsonAsset, TextAsset, director } from 'cc';
import { E_EventType, E_PlatformType } from './common/EnumBase';
import { App } from './common/manager/App';
var ccclass = _decorator.ccclass,
    property = _decorator.property;
export var Loading = (_dec = ccclass('Loading'), _dec2 = property(ProgressBar), _dec3 = property(JsonAsset), _dec4 = property(TextAsset), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Loading, _Component);

  function Loading() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "a_pb_res", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_json", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "ta_name", _descriptor3, _assertThisInitialized(_this));

    return _this;
  }

  var _proto = Loading.prototype;

  _proto.start = function start() {
    if (App.AdCtrl.platformType == E_PlatformType.Ad4399) {
      if (!App.GameCtrl.checkFromURL()) return;
    }

    App.CfgMgr.parseData(this.n_json.json);
    App.NameDBMgr.parseData(this.ta_name.text);
    App.ResMgr.preLoad();
    App.LocalDBMgr.init();
    App.DataMgr.init();
    App.SoundMgr.init();
    App.AdCtrl.init();
    this.a_pb_res.progress = 0.00001;
    this.addEventListenr();
  };

  _proto.onDestroy = function onDestroy() {
    // GameCtr.I.removeEventListener();
    this.removeEventListener();
  };

  _proto.addEventListenr = function addEventListenr() {
    //分数变更
    App.EventMgr.addEventLintener(E_EventType.Res_Load, this.handle_resLoad, this);
  };

  _proto.removeEventListener = function removeEventListener() {
    App.EventMgr.removeEvent(this);
  };

  _proto.handle_resLoad = function handle_resLoad(percent) {
    this.a_pb_res.progress = percent * 0.7; // this.a_n_actor.x = this.a_pb_res.totalLength * percent + this.a_pb_res.barSprite.node.x;

    if (percent == 1) {
      var self = this;
      director.preloadScene("Main", function (completeCount, totalCount) {
        self.a_pb_res.progress = 0.7 + completeCount / totalCount;
      }, function (err) {
        director.loadScene("Main");
      });
    }
  } // update (deltaTime: number) {
  //     // [4]
  // }
  ;

  return Loading;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "a_pb_res", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "n_json", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "ta_name", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
})), _class2)) || _class);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();